import { PriceUtils } from "../service/price-utils"
import { AlfredPricingModule } from "./alfred-pricing"

/** "1 990 kr/mån", "999 kr engångsavgift", "1 kr/sms" or "Ingår". */
export const formatAlfredModulePrice = (
  module: AlfredPricingModule,
): string => {
  const parts: string[] = []
  if (module.monthlyPriceSek) {
    parts.push(`${PriceUtils.format(module.monthlyPriceSek)}/mån`)
  }
  if (module.oneTimePriceSek) {
    parts.push(`${PriceUtils.format(module.oneTimePriceSek)} engångsavgift`)
  }
  if (module.unitPriceSek !== null && module.unitLabel) {
    parts.push(`${PriceUtils.format(module.unitPriceSek)}/${module.unitLabel}`)
  }
  return parts.length > 0 ? parts.join(" + ") : "Ingår"
}
